// extracted by mini-css-extract-plugin
export default {"msgM":"_16fe6bfaa4"};